import { GET, PUT } from '../annotations';
import { ascii } from '../converters';
import { TapServerError } from '../tap-server-error';
import { CallContext, VirtualTap } from '../virtual-tap-server';

export class MqttRelayService {
  keepAliveCounter = 0;

  get mqttRelayConfig() {
    if (!this.server.config.wireless) {
      this.server.config.wireless = {};
    }
    if (!this.server.config.wireless.protocols) {
      this.server.config.wireless.protocols = {};
    }
    if (!this.server.config.wireless.protocols.mqtt) {
      this.server.config.wireless.protocols.mqtt = {
        password: '',
        url: '',

        netKey: '',
      };
    }
    return this.server.config.wireless.protocols.mqtt;
  }

  constructor(public server: VirtualTap) {
    this.server.bindConfigToRoute({
      path: '/1024//50',
      get: true,
      put: true,
      item: () => this.mqttRelayConfig,
      key: 'brokerHostname',
      default: '',
      converter: ascii,
    });
    this.server.bindConfigToRoute({
      path: '/1024//51',
      get: true,
      put: true,
      item: () => this.mqttRelayConfig,
      key: 'brokerPort',
      default: '1883',
      converter: ascii,
    });
    this.server.bindConfigToRoute({
      path: '/1024//52',
      get: true,
      put: true,
      item: () => this.mqttRelayConfig,
      key: 'clientId',
      default: '',
      converter: ascii,
    });
    this.server.bindConfigToRoute({
      path: '/1024//53',
      get: true,
      put: true,
      item: () => this.mqttRelayConfig,
      key: 'username',
      default: '',
      converter: ascii,
    });
    this.server.bindConfigToRoute({
      path: '/1024//54',
      get: true,
      put: true,
      item: () => this.mqttRelayConfig,
      key: 'password',
      default: '',
      converter: ascii,
    });
    this.server.bindConfigToRoute({
      path: '/1024//55',
      get: true,
      put: true,
      item: () => this.mqttRelayConfig,
      key: 'relayNetKey',
      default: '',
      converter: ascii,
    });
  }

  @PUT({
    path: '/1024//57',
  })
  public putRelayCertificate(context: CallContext<Uint8Array>) {
    throw TapServerError.notImplemented();
  }

  @PUT({
    path: '/1024//58',
    payloadType: ascii,
  })
  public putTopicPrefix(context: CallContext<string>) {
    this.mqttRelayConfig.topicPrefix = context.body;
  }
}
